import { OfferService } from './offer_service.js';
// import { RemoveAdsDialog } from '../ui/dialog/remove_ads_dialog.js';
import { TriggerOfferDialog } from '../ui/dialog/trigger_offer_dialog.js';
import { DialogManager } from '../ui/dialog/dialog_manager.js';
import { ContinueOverlay } from '../ui/overlay/overlays/continue_overlay.js';
import type { OfferDto } from '../api/dto/offers.dto.js';
import { GlobalSettings } from '../global_settings.js';
import { crashCapture } from "../crash/crash_reporter.js";

export const PLACEMENT_TEMPLATES = [ 'remove_ads', 'rewards_dialog', 'continue_special_offer' ] as const;

export function canRenderPlacement( template: string ): boolean
{
  return ( PLACEMENT_TEMPLATES as readonly string[] ).includes( template );
}

/**
 * Presents an offer the server chose through a trigger decision. Unlike
 * openPlacementOffer this is not a tap: the decision itself is the reason to
 * show it, and the template decides where it goes — a standalone dialog, or a
 * panel inside whatever screen the entry point belongs to.
 * Returns false when nothing could be shown right now (the caller may retry).
 */
export function presentDecisionOffer( offer: OfferDto, trigger_event_id: string ): boolean
{
  if ( !GlobalSettings.PROMO_OFFERS_ENABLED ) return false;
  const template = offer.placement?.template ?? 'rewards_dialog';
  const placement_id = offer.placement?.id ?? 'auto_dialog';
  if ( !canRenderPlacement( template ) )
  {
    console.warn( `[Offers] Unsupported decision template: ${template}` );
    return false;
  }

  switch ( template )
  {
    case 'continue_special_offer':
      return ContinueOverlay.presentSpecialOffer( offer, trigger_event_id );
    // case 'remove_ads':
    //   DialogManager.openDialog( new RemoveAdsDialog( offer, placement_id ) );
    //   break;
    default:
      DialogManager.openDialog( new TriggerOfferDialog( offer, { placement_id, trigger_event_id } ) );
      break;
  }
  void OfferService.trackShown( offer.id, { placement: placement_id, placement_id, template, trigger_event_id } );
  return true;
}

/**
 * Maps server-declared placement templates to native UI. The server selects
 * the offer; this registry only decides how the already-authorized template
 * is rendered. Add future special entry points here without adding another
 * hard-coded offer id to a screen.
 */
export function openPlacementOffer( placement_id: string ): boolean
{
  const resolved = OfferService.getPlacementOffer( placement_id );
  if ( !resolved ) return false;

  if ( !canRenderPlacement( resolved.template ) )
  {
    const error = new Error( `Unsupported placement template: ${resolved.template}` );
    console.warn( `[Offers] ${error.message}` );
    crashCapture( error, { placement_id, offer_id: resolved.offer.id } );
    return false;
  }

  void OfferService.trackClicked( resolved.offer.id, {
    placement: placement_id,
    placement_id,
    template: resolved.template,
  } );

  switch ( resolved.template )
  {
    // case 'remove_ads':
    //   DialogManager.openDialog( new RemoveAdsDialog( resolved.offer, placement_id ) );
    //   return true;
    case 'rewards_dialog':
      DialogManager.openDialog( new TriggerOfferDialog( resolved.offer, { placement_id } ) );
      return true;
    case 'continue_special_offer':
      // Not a tap target: the Continue overlay picks it up when it opens.
      return false;
    default: return false;
  }
}
